<template>
  <div class="userManage">
    <box title="合作方管理">
      <div class="partManage__context">

        <div class="tool">
          <el-button type="primary" @click="addnew()" >新增</el-button>
        </div>
        <div class="tableList">
          <el-table :data="tableList" class="table" v-loading="loading">
            <el-table-column
              prop="accountName"
              align="center"
              label="合作方名称"
              show-overflow-tooltip
            >

            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="联系方式"
              show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
              prop="updateTime"
              align="center"
              label="更新时间"
              show-overflow-tooltip
            >
            </el-table-column>


            <el-table-column align="center" label="操作" width="180px">
              <template slot-scope="scope">
                <div class="btnGroup" v-show="!scope.row.issue">

                  <span class="table__list__btn" @click="change(scope.row)"  >
                    编辑
                  </span>
                  <span class="table__list__btn" @click="givepow(scope.row)"  >
                    权限
                  </span>
                  <span class="table__list__btn" @click="onDelete(scope.row)" >
                    删除
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="sizePage"
            layout="total,prev, pager, next, jumper"
            :total="totalSum"
          >
          </el-pagination>
        </div>
      </div>
    </box>
    <el-dialog
      title="新增合作方"
      width="25%"
      :visible.sync="dialog"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <el-form
        label-width="100px"
        class="onDialog__form"
        :model="numform"
        ref="numform"

      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="合作方名称" prop="version" >
              <el-input

                v-model="numform.accountName"
                type="text"
                placeholder="请输入合作方名称"
                size="large"
              ></el-input>
            </el-form-item
            ></el-col>
          <el-col :span="24">
            <el-form-item label="合作方手机号" prop="version" >
              <el-input

                v-model="numform.phone"
                type="text"
                size="large"
              ></el-input>
            </el-form-item
            ></el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑合作方"
      width="25%"
      :visible.sync="dialog2"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <el-form
        label-width="100px"
        class="onDialog__form"
        :model="numform"
        ref="numform"

      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="合作方名称" prop="version" >
              <el-input

                v-model="numform.accountName"
                type="text"
                placeholder="请输入合作方名称"
                size="large"
              ></el-input>
            </el-form-item
            ></el-col>
          <el-col :span="24">
            <el-form-item label="合作方手机号" prop="version" >
              <el-input

                v-model="numform.phone"
                type="text"
                size="large"
              ></el-input>
            </el-form-item
            ></el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure()">确 定</el-button>
        <el-button @click="dialog2 = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="授权组织"
      width="25%"
      :visible.sync="dialog3"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <div class="tree-data">
        <el-tree
          ref="cirtree"
          show-checkbox
          :data="cirTree"
          :props="defaultProps"
          :default-expanded-keys="defaultlist"
          :default-checked-keys="defaultlist"
          node-key="deptId"

          @check-change="handleCheckChange"
        ></el-tree>
      </div>


      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upload()">确 定</el-button>
        <el-button @click="dialog3 = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import box from "../../component/box";
import fFilter from "../../component/filter";
import editPwd from "./components/editPassword";
import Vue from "vue";
export default {
  name: "userMangerPage",
  components: { box, },
  data() {
    return {
      page: 1,
      sizePage: 10,
      totalSum: 0,
      loading:false,
      dialog3:false,
      dialog2:false,
      dialog:false,
      tableList: [],
      deptList: [],
      menusList: [],
      cirTree: [],
      defaultlist: [],
      id: "",
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      typeList:"",
      checekedList:[],
      numform:{
        accountName:"",
        phone:"",
      },

    };
  },
  methods: {
    handleCheckChange(data, checked, indeterminate){
      this.checekedList=[]
      let dataarr=this.$refs.cirtree.getCheckedNodes()
      for(let i=0;i<dataarr.length;i++){
        this.checekedList.push(dataarr[i].deptId)
      }

    },
    upload(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/account/authDept";
      param.data={

        "accountId":this.id,
        "deptIds":this.checekedList,

      }
      Axios.ajax(param).then((res)=>{
        if (res.resultCode == 0) {
          this.$message.success("授权成功！");
          this.dialog3=false
        }else{
          this.$message.warning(res.resultMessage);
        }
      })
    },
    givepow(data){
      this.dialog3=true
      this.id=data.id
      this.getcirlist()
    },
    getcirlist(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/account/getAuthDeptTree";
      param.data={

        "id":this.id,

      }
      Axios.ajax(param).then((res)=>{
        this.defaultlist=[]
        this.cirTree=res.data.children
     this.setName(res.data.children)
        this.checekedList=this.defaultlist
      })
    },
    setName(datas){ //遍历树  获取id数组
      for(var i in datas){
        if(datas[i].auth==true){
          this.defaultlist.push(datas[i].deptId)
        }

        if(datas[i].children){
          this.setName(datas[i].children);
        }
      }

    },
    change(data){
      this.dialog2=true
      this.numform.accountName=data.accountName
      this.numform.phone=data.phone
      this.id=data.id
    },
    sure(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/account/update";
      param.data={
        "accountName":this.numform.accountName,
        "phone":this.numform.phone,
        "id":this.id,

      }
      Axios.ajax(param).then((res)=>{

        if (res.resultCode == 0) {
          this.$message.success("修改成功！");
          this.dialog2=false
          this.queryTableList()
          this.numform={
            accountName:"",
            phone:"",
          }
        } else {
          this.$message.warning(res.resultMessage);
        }

      })
    },
    onDelete(data){

      let that=this
      this.$confirm("确认删除？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        let param = {};
        param.method="post";

        param.url="/account/delete";
        param.data={
          id:data.id,
        }

        Axios.ajax(param).then((res)=>{

          if(res.resultCode=='0'){
            this.$message.success("删除成功！");


            this.queryTableList()
          }else{
            this.$message.warning(res.resultMessage);
          }
        })
      })
    },
    confirm(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/account/add";
      param.data={
        "accountName":this.numform.accountName,
        "phone":this.numform.phone,

      }
      Axios.ajax(param).then((res)=>{

        if (res.resultCode == 0) {
          this.$message.success("新增成功！");
          this.dialog=false
          this.queryTableList()
        } else {
          this.$message.warning(res.resultMessage);
        }

      })

    },
    addnew(){
      this.dialog=true
    },
    refresh() {
      this.appType = "";
      this.issue = "";
      this.version = "";

      this.queryTableList();
    },

    pageChange(val) {
      this.page = val;
      this.queryTableList();
    },
    queryTableList(){
      this.loading = true;
      const params = {
        url: "/account/page",
        method: "post",
        data: {
          "pageNum": this.page,
          "showNum": this.sizePage,
        },
      };
      Axios.ajax(params).then((res)=>{

        this.loading = false;
        this.tableList = res.data.dataList;
        this.totalSum = res.data.totalNum;
      });
    },



  },
  created() {

  },
  computed: {
    uploadUrl() {
      return this.baseUrl + "app/version/uploadPackage";
    },
    headers() {
      return {
        authorization:sessionStorage.getItem("token"),
      };
    },

  },
  mounted() {
    this.menusList=Vue.prototype.menusList
    this.queryTableList();


  },
  watch: {


  },
};
</script>

<style lang="less" scoped>
.userManage {
  .partManage__context {
    height: 100%;
    padding: 0 36px;
    overflow: auto;
    position: relative;
    .tool {
      margin: 20px 0;
      width: 100%;
      text-align: right;
    }
    .tableList {
      margin-top: 20px;
      height: 74vh;
      .table {
        height: 90%;
        overflow: auto;
      }
    }
    .page {
      position: absolute;
      bottom: 0;
      right: 0;
      margin-bottom: 16px;
    }
  }
}
.partManage__context{
  height: 100%;
  overflow: auto;
  padding: 0 36px 36px 36px;
}
.search-blank {
  padding: 36px 36px 0 36px;
  display: flex;
  justify-content: space-between;
}
.btnGroup {
  cursor: pointer;
  color: #2a62ff;
  font-weight: normal;
  .table__list__btn {
    margin: 0 5px;
    display: inline-block;
  }
}
.tree-data{
  height: 300px;
  overflow: auto;
}
</style>

<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
